import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es7.string.pad-end";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.sort";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.regexp.search";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins.js";
import axios from "axios";
import { getToken } from "@/libs/util";
import config from "@/config";
import { pl_list, dldpget, dldpset } from "@/api/chuku";
export default {
  name: "areaClass",
  mixins: [packageTableMixins],
  data: function data() {
    var _this = this;

    return {
      //是否勾选ip
      IPbl: false,
      DGbl: false,
      //参数功能组的类型
      groupType: null,
      // 新增表单数据
      newForm: {
        settingName: "",
        productModel: ""
      },
      statusData3: [{
        value: "xciot-prod-cnsz",
        name: this.$t("Changelang.中国")
      }, {
        value: "xciot-prod-hk",
        name: this.$t("Changelang.香港")
      }, {
        value: "xciot-prod-us2",
        name: this.$t("美国")
      }, {
        value: "xciot-prod-eu",
        name: this.$t("Changelang.欧洲")
      }],
      formItem: {
        ip: "",
        port: null,
        select: null
      },
      modelFromData: [],
      did: null,
      showTPDL: null,
      openModel: false,
      modelList: [],
      cateList: [],
      nodeList: [],
      showSearchMore: false,
      form_filter: {
        country_code: "xciot-prod-cnsz",
        name: ""
      },
      // 顶部按钮
      topButtonList1: [{
        name: "新增",
        // 直接使用中文，避免国际化问题
        type: "primary",
        icon: "ios-add",
        method: this.addCom
      }],
      topButtonList: [{
        name: "查询",
        // 直接使用中文
        type: "primary",
        method: this.search
      }, {
        name: "重置",
        // 直接使用中文
        type: "error",
        method: this.reset
      }],
      suppliers: [{
        value: 1,
        label: this.$t("永泰")
      }, {
        value: 2,
        label: this.$t("盾创")
      }, {
        value: 3,
        label: this.$t("比特安")
      }, {
        value: 4,
        label: this.$t("贝塞尔")
      }, {
        value: 5,
        label: this.$t("易鑫诺")
      }, {
        value: 6,
        label: this.$t("博观")
      }, {
        value: 7,
        label: this.$t("菲尼基")
      }, {
        value: 8,
        label: this.$t("智寻")
      }, {
        value: 9,
        label: this.$t("大能国科")
      }, {
        value: 10,
        label: this.$t("博龙")
      }, {
        value: 11,
        label: this.$t("龙磊")
      }, {
        value: 12,
        label: this.$t("长江龙")
      }],
      searchReq: {
        mods: []
      },
      filteredSuppliers: [],
      tableData: [],
      columnsData: [{
        title: "设置名称",
        // 直接使用中文
        key: "setting_name",
        align: "left",
        minWidth: 120,
        tree: true
      }, {
        title: "型号",
        // 直接使用中文
        key: "model",
        align: "left",
        minWidth: 120,
        tree: true
      }, {
        title: "创建时间",
        // 直接使用中文
        key: "create_time",
        align: "left",
        minWidth: 120,
        tree: true
      }, {
        title: "操作",
        // 直接使用中文
        key: "explain",
        align: "center",
        width: 300,
        render: function render(h, _ref) {
          var row = _ref.row;
          var arr = [];
          arr.push(h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: "3px",
              color: "#2d8cf0"
            },
            props: {
              size: "small",
              type: "text"
            },
            on: {
              click: function click() {
                _this.setDevice(row);
              }
            }
          }, "设置设备" // 直接使用中文
          ));
          arr.push(h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: "3px",
              color: "#2d8cf0"
            },
            props: {
              size: "small",
              type: "text"
            },
            on: {
              click: function click() {
                _this.del(row);
              }
            }
          }, "删除" // 直接使用中文
          ));
          return h("div", arr);
        }
      }],
      tableLoading: false,
      tabletotallen: 0,
      border: true,
      stripe: true,
      moduleShow: false,
      reqBase: {
        page: 1,
        page_size: 10
      }
    };
  },
  computed: {
    // 避免国际化问题，直接返回中文
    placeholderText: function placeholderText() {
      return "请输入";
    }
  },
  components: {},
  methods: {
    fillDefaults: function fillDefaults(item) {
      console.log("itemitem", item);
      var newList = item.list.map(function (field) {
        return _objectSpread({}, field, {
          value: field.default_value
        }); // 创建新对象
      });
      item.list = newList;
    },
    edit: function edit(row) {
      console.log("编辑", row); // 这里添加编辑逻辑
    },
    setDevice: function setDevice(row) {
      console.log("设置设备", row);
      this.$router.push({
        path: "/deviceman/piliang/batchSettingsList",
        query: row
      }); // 这里添加设置设备逻辑
    },
    addCom: function addCom() {
      this.modelFromData = [];
      this.openModel = true; // 重置表单

      this.newForm = {
        settingName: "",
        productModel: ""
      };
    },
    handleLoadData: function handleLoadData(item, callback) {
      console.log("11111");

      var callbak = function callbak(res) {
        if (res.result === 0) {
          var data = res.body.list || [];

          for (var i in data) {
            var list = data[i];

            if (list.has_child === 1) {
              list._loading = false;
              list.children = [];
              list.parent_code = item.area_code;
              list.parent_name = item.area_name;
            }
          }

          callback(data);
        } else {// 处理错误
        }
      }; // area_list({
      //   page_size: -1,
      //   page: 1,
      //   parent_code: item.area_code,
      //   all: 1
      // })
      //     axios
      //     .post(`https://cn3.api.xcthings.com:6443/v3/smartbms/bmssettinglist`, {
      //        page: 1,
      //         page_size: 1,
      //         setting_name:this.form_filter.country_code,
      //         access_token: getToken()
      //     })
      // .then(res => {
      //   console.log('DSADSADA',res);
      //   callbak(res);
      // })
      // .catch(err => {
      //   // 处理错误
      // });

    },
    init: function init() {
      this.getPageSizeToStorage();
      this.getData();
    },
    formatDate: function formatDate(timestamp) {
      var date = new Date(timestamp * 1000);
      return date.toLocaleString();
    },

    /**
     * 初始化数据
     */
    getData: function getData() {
      var _this2 = this;

      var resultHttp = "";

      if (this.form_filter.country_code == "xciot-prod-cnsz") {
        resultHttp = "cn3";
      } else if (this.form_filter.country_code == "xciot-prod-hk") {
        resultHttp = "hk";
      } else if (this.form_filter.country_code == "xciot-prod-us2") {
        resultHttp = "us";
      } else {
        resultHttp = "eu";
      } // this.tableLoading = true;
      // let callbak = res => {
      //   this.tableLoading = false;
      //   if (res.data.result === 0) {
      //     let data = res.data.body.info || [];
      //     vm.tableData=data
      //     console.log(vm.tableData);
      //     vm.tabletotallen = res.data.body.total;
      //   } else {
      //     vm.tableData = [];
      //     this.$Message.error(res.errorMsg);
      //   }
      // };


      axios.post("https://".concat(resultHttp, ".api.xcthings.com:9823/v3/smartbms/bmssettinglist"), {
        page: this.reqBase.page,
        page_size: this.reqBase.page_size,
        setting_name: this.form_filter.name,
        access_token: getToken()
      }).then(function (res) {
        _this2.tabletotallen = res.data.body.total || 0;

        if (res.data.body.info && Array.isArray(res.data.body.info)) {
          _this2.tableData = res.data.body.info.map(function (item) {
            return _objectSpread({}, item, {
              create_time: _this2.formatDate(item.create_time)
            });
          });
        } else {
          _this2.tableData = [];
        }
      }).catch(function (err) {
        _this2.tableLoading = false;
      });
    },
    del: function del(row) {
      var _this3 = this;

      console.log("删除row", row);
      this.$Modal.confirm({
        title: "删除",
        content: "确定要删除 " + row.setting_name + " 吗？",
        onOk: function onOk() {
          // 使用箭头函数
          axios.post("https://cn3.api.xcthings.com:9823/v3/smartbms/bmssettingdel", {
            setting_id: row.setting_id,
            access_token: getToken()
          }).then(function (res) {
            if (res.data.result === 0) {
              _this3.$Message.success("删除成功");

              _this3.getData(); // 确保这里的 this 正确指向 Vue 实例

            } else {
              _this3.$Message.error("删除失败");
            }
          }).catch(function (error) {
            console.error("删除请求错误: ", error);

            _this3.$Message.error("请求失败");
          });
        }
      });
    },

    /**
     * 翻页
     */
    pageonChange: function pageonChange(index) {
      this.reqBase.page = index;
      this.getData();
    },

    /**
     * 筛选
     */
    showSearchParel: function showSearchParel() {
      this.$refs.search.expandPanel();
    },
    search: function search() {
      this.init();
    },
    reset: function reset() {
      this.form_filter = {
        country_code: "xciot-prod-cnsz",
        name: ""
      };
      this.search();
    },
    //转换保护参数
    transformParameterData: function transformParameterData(jsonData) {
      var _this4 = this;

      // 校验输入数据
      if (!Array.isArray(jsonData)) {
        console.error("输入数据必须是数组格式");
        return [];
      }

      var result = []; // 遍历每个参数组

      jsonData.forEach(function (group) {
        if (!group.list || !Array.isArray(group.list) || group.list.length === 0) {
          console.warn("\u53C2\u6570\u7EC4 ".concat(group.name, " \u7F3A\u5C11\u6709\u6548\u7684list\u6570\u636E\uFF0C\u8DF3\u8FC7"));
          return;
        } // 获取第一个参数的类型作为整个组的class


        var classType = _this4.groupType; // 获取组的group_id

        var groupId = group.list[0].group_id; // 按序号(xuhao)排序并提取值

        var groupValue = group.list.sort(function (a, b) {
          return a.xuhao - b.xuhao;
        }) // 按序号升序排序
        .map(function (param) {
          // 首先尝试获取原始值
          var value;

          try {
            // 尝试直接转换
            value = parseInt(param.value, 10); // 如果转换失败，尝试从字符串中提取数字

            if (isNaN(value) && param.now_value) {
              var match = param.now_value.match(/\d+/);
              value = match ? parseInt(match[0], 10) : 0;
            }
          } catch (e) {
            console.warn("\u53C2\u6570 ".concat(param.name_cn, " \u7684\u503C\u8F6C\u6362\u5931\u8D25:"), e);
            value = 0;
          } // ********** 新增处理：除以beilv再加上pianyi **********


          if (!isNaN(value) && param.beilv && param.pianyi !== undefined) {
            try {
              // 解析beilv和pianyi为数字
              var beilv = parseFloat(param.beilv);
              var pianyi = parseFloat(param.pianyi); // 确保beilv不为0

              if (beilv !== 0) {
                // 执行计算：value / beilv + pianyi
                value = value / beilv + pianyi;
              }
            } catch (calcError) {
              console.warn("\u53C2\u6570 ".concat(param.name_cn, " \u7684\u500D\u7387\u504F\u79FB\u8BA1\u7B97\u5931\u8D25:"), calcError);
            }
          }

          return value;
        }).filter(function (value) {
          return !isNaN(value);
        }); // 过滤掉无效值
        // 添加到结果数组

        result.push({
          class: classType,
          group_id: groupId,
          group_value: groupValue
        });
      });
      return result;
    },
    //转为byte
    convertEachToByteArray: function convertEachToByteArray(data) {
      // 检查输入
      if (!Array.isArray(data)) {
        throw new Error("输入必须是数组");
      }

      var result = [];
      console.log("datadata", data); // 遍历每个对象并单独转换

      data.forEach(function (item) {
        // 1. 判断 group_id 自身占用的字节数
        var groupIdByteLength = 2; // 默认2字节
        // 特殊情况: class=2 且 group_id=71，保持2字节

        if (item.class === 2 && item.group_id === 71) {
          groupIdByteLength = 2;
        } // group_id为317、71、81、0时用4字节
        else if (item.group_id === 317 || item.group_id === 71 || item.group_id === 81 || item.group_id === 0) {
            groupIdByteLength = 4;
          } else {
            groupIdByteLength = 2;
          } // 2. 判断 group_value 中每个值占用的字节数


        var valueByteLength = 2; // 默认2字节
        // 特殊情况: class=2 且 group_id=71，保持2字节

        if (item.class === 2 && item.group_id === 71) {
          valueByteLength = 2;
        } // group_id为317、71、81时用4字节
        else if (item.group_id === 317 || item.group_id === 71 || item.group_id === 81) {
            valueByteLength = 4;
          } else {
            valueByteLength = 2;
          } // 计算当前对象的字节数


        var byteCount = 1 + groupIdByteLength + item.group_value.length * valueByteLength; // 创建ArrayBuffer

        var buffer = new ArrayBuffer(byteCount);
        var dataView = new DataView(buffer);
        var offset = 0; // 写入class (uint8, 1字节)

        dataView.setUint8(offset, item.class);
        offset += 1; // 写入group_id (根据判断使用2或4字节，大端序)

        if (groupIdByteLength === 2) {
          dataView.setInt16(offset, item.group_id, false); // 使用signed 16-bit

          offset += 2;
        } else {
          dataView.setInt32(offset, item.group_id, false); // 使用signed 32-bit

          offset += 4;
        } // 写入group_value数组 (根据valueByteLength使用2或4字节)


        item.group_value.forEach(function (value) {
          if (valueByteLength === 2) {
            dataView.setInt16(offset, value, false); // 使用signed 16-bit

            offset += 2;
          } else {
            // 4字节
            dataView.setInt32(offset, value, false); // 使用signed 32-bit

            offset += 4;
          }
        }); // 转换为Uint8Array并添加到结果数组

        result.push(Array.from(new Uint8Array(buffer)));
      });
      return result;
    },
    // 11111111
    // 11111111
    // 11100000
    // 00000000
    // 00000000
    // 00000000
    // 00000000
    // 00000000
    // 0000
    // 0111
    // 1111
    // 1111
    // 1111
    // 111
    convertBinaryToByteArray: function convertBinaryToByteArray(binaryStr) {
      console.log("binaryStr", binaryStr); // 1. 确保输入是64位的二进制字符串

      if (binaryStr.length !== 64) {
        throw new Error("输入必须是64位二进制字符串");
      } // 2. 将字符串倒序


      var reversed = binaryStr.split("").reverse().join("");
      console.log("binaryStr", reversed); // 3. 每8位一组转换为字节

      var bytes = [];

      for (var i = 0; i < 64; i += 8) {
        var byteStr = reversed.substr(i, 8); // 将二进制字符串转换为十进制数字

        var byteValue = parseInt(byteStr, 2);
        bytes.push(byteValue);
      } // 4. 在数组最前面添加 groupType（根据要求，1,2,3 变为 01,02,03）
      // groupType 是 uint8，直接添加即可


      bytes.unshift(this.groupType);
      return bytes;
    },
    //端口转byte
    encodeServerConfig: function encodeServerConfig(domain, port) {
      var littleEndian = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      // 1. 将域名转换为UTF-8字节数组
      var encoder = new TextEncoder();
      var domainBytes = encoder.encode(domain);
      var domainLength = domainBytes.length; // 2. 创建总Uint8Array (4字节端口 + 2字节长度 + 域名字节)

      var totalBytes = 4 + 2 + domainLength;
      var uint8Array = new Uint8Array(totalBytes); // 3. 使用DataView写入数据（按照字段顺序）

      var dataView = new DataView(uint8Array.buffer); // 第一个字段：port (uint32, 4字节)

      dataView.setUint32(0, port, littleEndian); // 第二个字段：ip_addr_len (uint16, 2字节)

      dataView.setUint16(4, domainLength, littleEndian); // 第三个字段：ip_addr (uint8数组，从偏移量6开始)

      for (var i = 0; i < domainLength; i++) {
        uint8Array[6 + i] = domainBytes[i];
      }

      return uint8Array;
    },
    handleOk: function handleOk() {
      var _this5 = this;

      if (this.newForm.settingName === "" || this.newForm.productModel === "") {
        this.$Message.error("\u540D\u79F0\u548C\u4EA7\u54C1\u578B\u53F7\u5FC5\u987B");
        return;
      }

      var hasCheckedGroup = this.modelFromData.some(function (group) {
        return group.checked;
      });

      if (!hasCheckedGroup && this.IPbl == false && this.DGbl == false) {
        return;
      }

      var hasError = false;
      var errorGroupName = "";
      var errorFieldName = ""; // 检查所有组（排除功能参数组）

      for (var i = 0; i < this.modelFromData.length; i++) {
        var group = this.modelFromData[i];

        if (group.checked) {
          // 功能参数组跳过检查
          if (group.name === "功能参数") {
            continue;
          } // 继电器控制组特殊检查：不能都同时关闭


          if (group.name === "继电器控制") {
            var allClosed = group.list.every(function (field) {
              return field.value === undefined || field.value === false || field.value === 0;
            });

            if (allClosed) {
              hasError = true;
              errorGroupName = group.name;
              errorFieldName = "至少需要开启一个继电器";
              break;
            } // 继电器控制组不进行单个字段的空值检查


            continue;
          } // 其他组进行正常空值检查


          for (var j = 0; j < group.list.length; j++) {
            var field = group.list[j];

            if (field.value === undefined || field.value === false) {
              hasError = true;
              errorGroupName = group.name;
              errorFieldName = field.name_cn;
              break;
            }
          }

          if (hasError) break;
        }
      }

      if (hasError) {
        this.$Message.error("".concat(errorGroupName, "\u7EC4\u4E2D\u7684").concat(errorFieldName, "\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u586B\u5199\u5B8C\u6574"));
        return;
      }

      var dps = []; // 用于存储所有 dps
      // 处理功能参数组

      var functionParamGroups = this.modelFromData.filter(function (group) {
        return group.checked && group.name === "功能参数";
      }); // 处理其他参数组（不包括功能参数）

      var checkedNonFunctionGroups = this.modelFromData.filter(function (group) {
        return group.checked && group.name !== "功能参数";
      }); // 分离继电器控制组和其他非功能参数组

      var relayControlGroups = checkedNonFunctionGroups.filter(function (group) {
        return group.name === "继电器控制";
      });
      var otherNonFunctionGroups = checkedNonFunctionGroups.filter(function (group) {
        return group.name !== "继电器控制";
      }); // 情况1：只有功能参数组

      if (functionParamGroups.length > 0 && checkedNonFunctionGroups.length === 0) {
        // ... 原有的功能参数组处理代码 ...
        var resultString = functionParamGroups[0].list.map(function (item, index) {
          var bit = item.value === undefined || item.value === false ? "0" : "1";
          return bit;
        }).join("");

        if (this.groupType === 2 && resultString.length >= 8) {
          resultString = resultString.slice(0, 8) + "0" + resultString.slice(8);
        }

        resultString = resultString.padEnd(64, "0");
        var groupTypeId = this.groupType === 3 ? 2905 : 2262;
        dps.push({
          dp_id: groupTypeId,
          dp_chan: 0,
          dp_type: 4,
          val_raw: this.convertBinaryToByteArray(resultString)
        });
      } // 情况2：只有非功能参数组
      else if (functionParamGroups.length === 0 && checkedNonFunctionGroups.length > 0) {
          console.log("checkedNonFunctionGroups", checkedNonFunctionGroups); // 处理继电器控制组

          if (relayControlGroups.length > 0) {
            relayControlGroups.forEach(function (relayGroup) {
              // 遍历继电器组的每个字段
              relayGroup.list.forEach(function (field) {
                // 根据 name_cn 确定 dp_chan 和 dp_id
                var dp_chan;
                var dp_id = _this5.groupType === 3 ? 2902 : 2259; // 默认 dp_id

                var value = 0; // 初始化 value 变量

                if (field.type == 1000) {
                  if (field.name_cn.includes("快充继电器")) {
                    dp_chan = 1;
                  } else if (field.name_cn.includes("慢充继电器")) {
                    dp_chan = 2;
                  } else if (field.name_cn.includes("放电继电器")) {
                    dp_chan = 3;
                  } else if (field.name_cn.includes("预充继电器")) {
                    dp_chan = 4;
                  } else if (field.name_cn.includes("负极继电器")) {
                    dp_chan = 5;
                  } else if (field.name_cn.includes("加热膜继电器")) {
                    dp_chan = 6;
                    dp_id = 2271; // 如果是加热膜继电器，改为 dp_id: 2271

                    value = field.value; // 直接使用 field.value
                  }
                } else {
                  if (field.name_cn.includes("充电继电器")) {
                    dp_chan = 1;
                  } else if (field.name_cn.includes("放电继电器")) {
                    dp_chan = 2;
                  }
                } // 对于不是加热膜继电器的情况，将值转换为 0 或 1


                if (dp_chan !== 6) {
                  // 确保 dp_chan 不是加热膜继电器
                  value = field.value === true || field.value === 1 ? 1 : 0;
                } // 确保 dp_chan 有值，才能推入 dps 数组


                if (dp_chan !== undefined) {
                  dps.push({
                    dp_id: dp_id,
                    // 使用条件判断后的 dp_id
                    dp_chan: dp_chan,
                    dp_type: 1,
                    // 继电器使用 type 1 (整数)
                    val_int64: value
                  });
                }
              });
            });
          } // 处理其他非功能参数组


          if (otherNonFunctionGroups.length > 0) {
            var data = this.transformParameterData(otherNonFunctionGroups); // 遍历每条数据，创建单个 dps 对象

            data.forEach(function (item) {
              var byteArray = _this5.convertEachToByteArray([item]);

              var flattenedByteArray = byteArray.flat();
              var groupTypeId = _this5.groupType === 3 ? 2902 : 2259;
              dps.push({
                dp_id: groupTypeId,
                dp_chan: 0,
                dp_type: 4,
                val_raw: flattenedByteArray
              });
            });
          }

          console.log("只包含非功能参数组的转换结果:", dps);
        } // 情况3：两种类型组都有
        else if (functionParamGroups.length > 0 && checkedNonFunctionGroups.length > 0) {
            // 处理功能参数组
            var _resultString = functionParamGroups[0].list.map(function (item, index) {
              var bit = item.value === undefined || item.value === false ? "0" : "1";
              return bit;
            }).join("");

            if (this.groupType === 2 && _resultString.length >= 8) {
              _resultString = _resultString.slice(0, 8) + "0" + _resultString.slice(8);
            }

            _resultString = _resultString.padEnd(64, "0");
            var functionGroupTypeId = this.groupType === 3 ? 2905 : 2262;
            dps.push({
              dp_id: functionGroupTypeId,
              dp_chan: 0,
              dp_type: 4,
              val_raw: this.convertBinaryToByteArray(_resultString)
            }); // 处理继电器控制组

            if (relayControlGroups.length > 0) {
              relayControlGroups.forEach(function (relayGroup) {
                // 遍历继电器组的每个字段
                relayGroup.list.forEach(function (field) {
                  // 根据 name_cn 确定 dp_chan 和 dp_id
                  var dp_chan;
                  var dp_id = _this5.groupType === 3 ? 2902 : 2259; // 默认 dp_id

                  var value = 0; // 初始化 value 变量

                  if (field.type == 1000) {
                    if (field.name_cn.includes("快充继电器")) {
                      dp_chan = 1;
                    } else if (field.name_cn.includes("慢充继电器")) {
                      dp_chan = 2;
                    } else if (field.name_cn.includes("放电继电器")) {
                      dp_chan = 3;
                    } else if (field.name_cn.includes("预充继电器")) {
                      dp_chan = 4;
                    } else if (field.name_cn.includes("负极继电器")) {
                      dp_chan = 5;
                    } else if (field.name_cn.includes("加热膜继电器")) {
                      dp_chan = 6;
                      dp_id = 2271; // 如果是加热膜继电器，改为 dp_id: 2271

                      value = field.value; // 直接使用 field.value
                    }
                  } else {
                    if (field.name_cn.includes("充电继电器")) {
                      dp_chan = 1;
                    } else if (field.name_cn.includes("放电继电器")) {
                      dp_chan = 2;
                    }
                  } // 对于不是加热膜继电器的情况，将值转换为 0 或 1


                  if (dp_chan !== 6) {
                    // 确保 dp_chan 不是加热膜继电器
                    value = field.value === true || field.value === 1 ? 1 : 0;
                  } // 确保 dp_chan 有值，才能推入 dps 数组


                  if (dp_chan !== undefined) {
                    dps.push({
                      dp_id: dp_id,
                      // 使用条件判断后的 dp_id
                      dp_chan: dp_chan,
                      dp_type: 1,
                      // 继电器使用 type 1 (整数)
                      val_int64: value
                    });
                  }
                });
              });
            } // 处理其他非功能参数组


            if (otherNonFunctionGroups.length > 0) {
              var _data = this.transformParameterData(otherNonFunctionGroups);

              _data.forEach(function (item) {
                var byteArray = _this5.convertEachToByteArray([item]);

                var flattenedByteArray = byteArray.flat();
                var groupTypeId = _this5.groupType === 3 ? 2902 : 2259;
                dps.push({
                  dp_id: groupTypeId,
                  dp_chan: 0,
                  dp_type: 4,
                  val_raw: flattenedByteArray
                });
              });
            }

            console.log("包含两种类型组的转换结果:", dps);
          }

      var result = {
        t: 0,
        timestamp: Date.now(),
        ans: false,
        dpv_count: dps.length,
        // 修正为实际dps数量
        dps: dps
      }; // ... 后续的IP和select处理代码保持不变 ...

      if (this.IPbl && this.formItem.ip && this.formItem.port) {
        var base64Config = this.encodeServerConfig(this.formItem.ip, this.formItem.port, false);
        var ipData = {
          dp_id: 2315,
          dp_type: 4,
          dp_chan: 0,
          val_raw: _toConsumableArray(base64Config)
        };
        result.dps.push(ipData);
        result.dpv_count = result.dps.length;
      }

      if (this.DGbl && this.formItem.select) {
        var cjData = {
          dp_id: 2312,
          dp_type: 1,
          dp_chan: 0,
          val_int64: this.formItem.select
        };
        result.dps.push(cjData);
        result.dpv_count = result.dps.length;
      }

      console.log("最终发送的数据:", result);
      axios.post("https://cn3.api.xcthings.com:9823/v3/smartbms/bmssettingadd", {
        setting_name: this.newForm.settingName,
        access_token: getToken(),
        model: this.newForm.productModel,
        dpcmd: result
      }).then(function (res) {
        console.log("下发结果", res);

        if (res.data.result == 0) {
          _this5.$Message.success("保存成功");

          _this5.openModel = false;
          _this5.formItem = {};
          _this5.newForm.productModel = {};
          _this5.showTPDL = 0;

          _this5.getData();
        } else {
          _this5.$Message.error("保存失败");
        }
      }).catch(function (error) {
        _this5.$Message.error("请求失败，请检查网络连接");
      });
    },
    cancel: function cancel() {
      console.log("取消", this.formItem);
      this.openModel = false;
      this.showTPDL = 0;
      this.IPbl = false;
      this.DGbl = false;
      this.formItem = {};
    },
    parseSupplierIds: function parseSupplierIds(base64Str) {
      var binaryString = atob(base64Str);
      var bytes = new Uint8Array(binaryString.length);

      for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      var count = bytes[0] << 8 | bytes[1];
      var result = [];

      for (var _i = 0; _i < count; _i++) {
        var offset = 2 + _i * 2;
        var id = bytes[offset] << 8 | bytes[offset + 1];
        result.push(id);
      }

      return result; // 返回剩下的 id 数组
    },
    buildQueryBuffer: function buildQueryBuffer(options) {
      var sdid = options.sdid,
          dp_id = options.dp_id,
          dp_chan = options.dp_chan,
          _options$lz4SrcLength = options.lz4SrcLength,
          lz4SrcLength = _options$lz4SrcLength === void 0 ? 0 : _options$lz4SrcLength,
          _options$littleEndian = options.littleEndian,
          littleEndian = _options$littleEndian === void 0 ? false : _options$littleEndian;
      var dpChansArr = Array.isArray(dp_chan) ? _toConsumableArray(dp_chan) : [dp_chan];
      var dpIdsArr = Array.isArray(dp_id) ? _toConsumableArray(dp_id) : [dp_id];
      console.log("dps配置项=====>", JSON.stringify({
        sdid: sdid,
        chans: dpChansArr,
        dpids: dpIdsArr
      }));
      var encoder = new TextEncoder();
      var queryBytesList = []; // 为每个dp_id创建一个查询条件

      for (var i = 0; i < dpIdsArr.length; i++) {
        var queryObj = {
          sdid: sdid[0] || "",
          // 取第一个sdid
          chans: [dpChansArr[i] || dpChansArr[0] || 0],
          // 使用对应的dp_chan
          dpids: [dpIdsArr[i]]
        };
        queryBytesList.push(encoder.encode(JSON.stringify(queryObj)));
      }

      var totalLen = 2 + 1 + queryBytesList.reduce(function (sum, b) {
        return sum + 2 + b.length;
      }, 0);
      var buffer = new ArrayBuffer(totalLen);
      var dv = new DataView(buffer);
      var offset = 0;
      dv.setUint16(offset, lz4SrcLength, littleEndian);
      offset += 2;
      dv.setUint8(offset, queryBytesList.length);
      offset += 1;

      for (var _i2 = 0; _i2 < queryBytesList.length; _i2++) {
        var bytes = queryBytesList[_i2];
        dv.setUint16(offset, bytes.length, littleEndian);
        offset += 2;
        new Uint8Array(buffer, offset, bytes.length).set(bytes);
        offset += bytes.length;
      }

      return new Uint8Array(buffer);
    },
    requestDeviceeReportOnce: function () {
      var _requestDeviceeReportOnce = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(options) {
        var mergedOption, unit8Data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!Array.isArray(options) || options.length === 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                // 将多个查询条件合并成一个
                mergedOption = {
                  did: options[0].did,
                  sdid: options[0].sdid,
                  // 使用第一个的sdid
                  dp_id: options.map(function (item) {
                    return item.dp_id;
                  }),
                  // 收集所有的dp_id
                  dp_chan: options.map(function (item) {
                    return item.dp_chan;
                  }),
                  // 收集所有的dp_chan
                  lz4SrcLength: options[0].lz4SrcLength || 0,
                  littleEndian: options[0].littleEndian || false
                };
                unit8Data = this.buildQueryBuffer(mergedOption);
                return _context.abrupt("return", [{
                  dp_id: 3556,
                  dp_chan: 0,
                  dp_type: 4,
                  val_raw: _toConsumableArray(unit8Data)
                }]);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function requestDeviceeReportOnce(_x) {
        return _requestDeviceeReportOnce.apply(this, arguments);
      }

      return requestDeviceeReportOnce;
    }(),
    parseServerConfig: function parseServerConfig(base64Str) {
      var littleEndian = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // 1. Base64解码
      var binaryStr = atob(base64Str);
      var bytes = new Uint8Array(binaryStr.length);

      for (var i = 0; i < binaryStr.length; i++) {
        bytes[i] = binaryStr.charCodeAt(i);
      }

      var dataView = new DataView(bytes.buffer);
      var offset = 0; // 2. 解析port (uint32, 4字节)

      var port = dataView.getUint32(offset, littleEndian);
      offset += 4; // 3. 解析ip_addr_len (uint16, 2字节)

      var ipAddrLen = dataView.getUint16(offset, littleEndian);
      offset += 2; // 4. 解析ip_addr (长度为ipAddrLen的字符串)

      var ipAddr = "";

      for (var _i3 = 0; _i3 < ipAddrLen; _i3++) {
        ipAddr += String.fromCharCode(bytes[offset + _i3]);
      }

      return {
        port: port,
        ipAddrLen: ipAddrLen,
        ipAddr: ipAddr
      };
    },
    changeAddList: function changeAddList() {
      var _this6 = this;

      this.modelFromData = [];
      pl_list({
        model_code: this.newForm.productModel,
        country_code: this.form_filter.country_code
      }).then(function (res) {
        console.log("rasdsad", res);
        _this6.groupType = res.other.device.device_type;
        _this6.modelFromData = res.body.map(function (item) {
          return _objectSpread({}, item, {
            checked: false
          });
        });
        _this6.showTPDL = res.other.is_dk;

        if (res.other.dk_dgcj_did.length > 0) {
          _this6.did = res.other.dk_dgcj_did[0].did; // this.did='PACEICGBMSMT0013AFF664DB'
        }
      });
    },
    //获取新增是的参数列表设置
    getAddList: function getAddList() {
      var _this7 = this;

      axios.post("https://cn3.api.xcthings.com:9823/v3/smartbms/bmssettingdevicemodel", {
        php_token: getToken(),
        access_token: getToken()
      }).then(function (res) {
        _this7.modelList = res.data.body.model;
        pl_list({
          model_code: res.data.body.model[0],
          country_code: _this7.form_filter.country_code
        }).then(function (res) {
          console.log("rasdsad", res);
          _this7.groupType = res.other.device.device_type;
          _this7.modelFromData = res.body.map(function (item) {
            return _objectSpread({}, item, {
              checked: false
            });
          });
        });
      });
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    this.$set(this.reqBase, "project_code", this.$store.state.user.projectCode);
    setTimeout(function () {
      _this8.init();
    }, 1000);
    this.getAddList();
  },
  created: function created() {},
  destroyed: function destroyed() {
    window.onresize = null;
  }
};